export default {
  title: 'hello',
  message: {
    contactservice: 'Please contact customer service!',
    enterNewPassword: 'Please enter new password',
    passwordLengthError: 'Password must be at least 6 characters',
    reenterNewPassword: 'Please re-enter new password',
    passwordComplexityError:
      ' Password must include uppercase and lowercase letters, numbers, and special characters',
    passwordMismatchError: 'Passwords do not match, please check and try again',
    enterPhoneNumber: 'Please enter phone number',
    enterEmail: 'Please enter email',
    enterVerificationCode: 'Please enter verification code',
    enterCurrentPassword: 'Please enter current password',
    updateSuccess: 'Update Successful',
    copySuccess: 'Copy Successful',
    withdrawalAmountGreaterThanZero: 'Withdrawal amount must be greater than 0',
    operationSuccess: 'Request Successful',
    registrationSuccess: 'Registration Successful',
    transferSuccess: 'Transfer Successful',
    redemptionSuccess: 'Redemption Successful',
    enterPassword: 'Please enter password',
    reenterPassword: 'Please re-enter password',
    agreeToPrivacyPolicy: 'Please read and agree to the User Privacy Policy',
    confirm: 'Confirm',
    cancel: 'Cancel',
    isImmediateRedeem: 'Do you want to redeem immediately?',
    confirmWithdrawal: 'Are you sure to confirm this withdrawal?',
    prompt: 'Prompt',
    save: 'Save',
    saveSuccess: 'Save Successful',
    loginout: 'Are you sure to log out?',
    addressEmpty: 'Address cannot be empty',
  },
  sidebar: {
    home: 'Home',
    shop: 'Shop',
    memberpointsdetail: 'Membership Points Details',
    switchLanguage: 'Switch Language',
    accountManagement: 'Account Management',
    memberManagement: 'VIP Management',
    menu: 'Menu',
    logout: 'Logout',
    accountInfo: 'My Account',
    changePassword: 'Change Password',
    bindPhone: 'Bind Phone Number',
    viewLoginRecords: 'View Login History',
    memberPersonalInfo: 'My VIP',
    referrerInfo: 'My Referrer',
    myteam: 'My Team',
    teamStructure: 'Team Structure',
    lowerMemberData: 'Downline Member Data',
    memberVipStatus: 'VIP Status',
    bonusManagement: 'My Bonus',
    incomeDetails: 'Bonus Details',
    eWallet: 'E-Wallet',
    purchasePackage: 'VIP Orders',
    selectPackage: 'Choose Plan',
    memberBenefitsDescription: 'VIP Benefits Description',
    purchaseRecords: 'VIP Order History',
    orderManagement: 'My Shop Orders',
    pointsSystem: 'My Points',
    myVouchers: 'My Vouchers',
    messageNotifications: 'Notifications',
  },
  login: {
    login: 'Login',
    returnToLogin: 'Return to login',
    accountLogin: 'Account Login',
    phoneQuickLogin: 'Phone Login',
    enterPhoneOrEmail: 'Please enter email/User ID/Username',
    enterPassword: 'Please enter password',
    enterPhoneNumber: 'Please enter phone number',
    pleaseSelect: 'Please Select',
    enterVerificationCode: 'Please enter verification code',
    sendVerificationCode: 'Send Code',
    rememberLogin: 'Remember Login',
    forgotPassword: 'Forgot Password?',
    registerAccount: 'Register',
    agreeToTerms: 'I have read and agree to',
    userAgreement: 'User Agreement',
    and: 'and',
    username: 'Username',
    enterusername: 'Please enter Username',
    privacyPolicy: 'Privacy Policy',
    allContents: 'all contents',
    back: 'Back',
    register: 'Register',
    registersuccess: 'Registered Successfully',
    phoneRegistration: 'Phone Registration',
    emailRegistration: 'Email Registration',
    enterEmail: 'Please enter email',
    shoplazzaRegistrationNote:
      'Already have a Shoplazza account? Please use the same email to continue.',
    verificationCode: 'Verification Code',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    enterReferrerId: 'Please Enter Invite Code',
    referrerId: 'Invite Code',
    registerAndLoginNow: 'Register',
    forgotPasswordTitle: 'Forgot Password',
    newPassword: 'New Password',
    enterNewPassword: 'Please Enter New Password',
    confirmNewPassword: 'Confirm New Password',
    registeredPhone: 'Registered Phone Number',
    registeredEmail: 'Registered Email',
    useEmail: 'Use Email',
    usePhone: 'Use Phone Number',
    enterRegisteredPhone: 'Please Enter Registered Phone number',
    enterRegisteredEmail: 'Please Enter Registered Email',
    submit: 'Submit',
    userAgreementText: 'User Agreement',
    privacyPolicyText: 'Privacy Policy',
  },
  index: {
    home: 'Home',
    TiersOrTotal: 'Within 10 Tiers / Total',
    TiersActiveOrTotal: '10 Tiers Active / 10 Tiers Total',
    EighteenTiersActiveOrTotal: '18 Tiers Active / 18 Tiers Total',
    vipLevel: 'VIP Level',
    vipPoints: 'VIP Points',
    commissions: 'Bonus',
    teamSize: 'Team Size',
    totalOrders: 'Total Orders',
    last7Days: 'Last 7 Days',
    last15Days: 'Last 15 Days',
    last30Days: 'Last 30 Days',
    commissionRanking: 'Top Earnings',
    history: 'History',
    account: 'Account',
    commission: 'Bonus',
    incomeTrendChart: 'Earnings Trend',

    incomeName: 'Income Name',
    incomeAmount: 'Income Amount',
    generatedTime: 'Generated Time',
  },
  accountInfo: {
    accountInfo: 'My Account',
    lastName: 'Last Name',
    firstName: 'First Name',
    company: 'Company',
    contactInfo: 'Contact Information',
    boundEmail: 'Email Address',
    address: 'address',
    Edits: 'Remaining Edits 1/1',
    Edit: 'Edit',
    changeUserID: 'Edit User ID',
    changeUserIDNote:
      'This is a one-time change. Please review carefully before confirming.',
    confirm: 'Confirm',
    cancel: 'Cancel',
    enter6DigitNumber: 'Please enter a 6-digit number',
    bankPaymentInfo: 'Bank Payment Information',
    provideRealNameAndAddress: 'Please provide your real name and address',
  },
  changepassword: {
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    enterCurrentPassword: 'Please Enter Your Current Password',
    forgotPassword: 'Forgot Password?',
    newPassword: 'New Password',
    enterNewPassword: 'Please Enter Your New Password',
    confirmNewPassword: 'Confirm New Password',
    reenterNewPassword: 'Please Re-Enter Your New Password',
    resetPassword: 'Forgot Password',
    registeredPhone: 'Registered Phone Number',
    registeredEmail: 'Registered Email',
    useEmail: 'Use Email',
    usePhone: 'Use Phone Number',
    pleaseSelect: 'Please Select',
    verificationCode: 'Verification Code',
    enterPhoneNumber: 'Please Enter Phone Number',
    enterVerificationCode: 'Please Enter Verification Code',
    sendCode: 'Send Code',
    cancel: 'Cancel',
    submit: 'Submit',
    passwordLengthError: 'Password Must Be At least 6 characters',
    passwordMismatchError: 'Passwords do not match, please check',
  },
  bindphone: {
    bindPhone: 'Bind Phone Number',
    phoneNumber: 'Phone Number',
    enterPhoneNumber: 'Please enter phone number',
    pleaseSelect: 'Please Select',
    verificationCode: 'Verification Code',
    enterVerificationCode: 'Please enter verification code',
    sendVerificationCode: 'Send Code',
    submit: 'Submit',
  },
  loginRecord: {
    loginRecords: 'Login History',
    loginRecordsDesc:
      'The following are your Login History from the last 3 months. If there are any unusual Login History, please promptly',
    changePassword: 'Change Your Password',
    loginIp: 'Login IP',
    loginMethod: 'Login Method',
    loginTime: 'Login Time',
    loginLocation: 'Login Location',
    emailLogin: 'Email Login',
    phoneLogin: 'Phone Number Login',
  },
  memberinfo: {
    memberPersonalInfo: 'My VIP',
    basicInfo: 'Basic Information',
    lastName: 'Last Name',
    firstName: 'First Name',
    company: 'Company',
    contactInfo: 'Contact Information',
    referrerId: 'Invite Code',
    invitationLink: 'Invitation Link',
    referralQrcode: 'Referral QR Code',
  },
  referrerinfo: {
    referrerInfo: 'My Referrer',
    basicInfo: 'Basic Information',
    lastName: 'Last Name',
    firstName: 'First Name',
    company: 'Company',
    contactInfo: 'Contact Information',
    referrerId: 'Invite Code',
  },
  tree: {
    basicInfo: 'Basic Information',
    fullName: 'Full Name',
    company: 'Company',
    contactInfo: 'Contact Information',
    referrerId: 'Referrer ID',
    invitationLink: 'Invitation Link',
    referralQrcode: 'Referral QR Code',
    teamStructure: 'Team Structure',
    noData: 'No Data',
    noPermission: 'No permission to view',
  },
  lowermemberdata: {
    lowerMemberData: 'Downline Member Data',
    account: 'Account',
    remainingVipPoints: 'Remaining VIP Points',
    vipStatus: 'VIP Status',
    vipPackageName: 'VIP Plan Name',
    affiliatedNode: 'Parent Node',
    packageExpiryTime: 'VIP Plan Expiration Time',
    noData: 'No Data',
    active: 'Active',
    inactive: 'Inactive',
    vipInactive: 'VIP Inactive',
    nonVip: 'Non-VIP',
    influencer: 'Affiliate Partner',
  },
  memberstatus: {
    memberVipStatus: 'VIP Status',
    basicInfo: 'Basic Information',
    memberValidityPeriod: 'VIP Plan Validity',
    memberLevel: 'VIP Level',
    activeStatus: 'Active Status',
    contactInfo: 'Contact Information',
    referrerId: 'Invite Code',
  },
  incomedetails: {
    incomeDetails: 'Bonus Details',
    pleaseSelect: 'Please Select',
    filter: 'Filter',
    money: 'Bonus',
    transactionNumber: 'Transaction Number',
    creditTime: 'Deposit Time',
    withdrawalTime: 'Available Withdrawal Time',
    noData: 'No Data',
    dividendTime: 'Dividend Time',
    dividendType: 'Dividend Type',
    sourceObject: 'Source Object',
    bonusAmount: 'Bonus Amount',
    totalRP: 'Total RP',
    rpAmount: 'RP Amount',
    settlementStatus: 'Settlement Status',
    totalBonusAmount: 'Total Bonus Amount',
    recentBonusTime: 'Recent Bonus Time',
    detailList: 'Bonus Details',
    dividendOverview: 'Dividend Overview',
    remark: 'Note',
    revokeAmount: 'Revoke Amount',
  },
  LTP10: {
    title: '10 Level Team Performance',
    userId: 'User ID',
    userName: 'User Name',
    teamMemberCount: 'Team Member Count',
    teamAccumulatedPerformance: 'Team Accumulated Performance',
    startDate: 'Start Date',
    endDate: 'End Date',
    createtime: 'Registration Time',
  },
  ewallet: {
    withdrawalServiceComingSoon: 'Withdrawal service is coming soon',
    refunded: 'Refunded',
    none: 'Awaiting Processing',
    money: 'Balance',
    pending: 'In Settlement',
    available: 'Credited',
    partial_revoke: 'Partially Revoked',
    revoked: 'Revoked',
    available_unlock: 'Unfreeze',
    eWallet: 'E-Wallet',
    walletBalance: 'Wallet Balance',
    transactionDetails: 'Transaction Details',
    withdrawalRecords: 'Withdrawal History',
    pendingSettlement: 'Pending',
    credited: 'Available',
    withdrawable: 'Withdrawable',
    vipStatus: 'VIP Status',
    vipActivated: 'Active',
    vipInactivated: 'Inactive',
    applyWithdrawal: 'Apply for Withdrawal',
    enterWithdrawalAmount: 'Please enter withdrawal amount',
    viptip: 'No permission at the moment, please activate your VIP',
    withdrawNow: 'Withdraw Now',
    pleaseSelect: 'Please Select',
    filter: 'Filter',
    transactionNumber: 'Transaction Number',
    creditTime: 'Deposit Time',
    noData: 'No Data',
    rejectionReason: 'Rejection Reason',
    reviewTime: 'Review Time',
    underReview: 'Under Review',
    processing: 'Processing',
    completed: 'Completed',
    success: 'Success',
    exchangeHP: 'Exchange GP',
    rejected: 'Rejected',
    rewardExchangeHp: 'Reward points exchange for GP',
    pleaseEnterRewardToExchange: 'Please enter the reward points to exchange',
    youWillGet: 'You will get',
    confirm: 'Confirm exchange',
    enter: 'Please enter',
    sourceObjectUuid: 'Source Object UUID',
    sourceObjectUserName: 'Source Object User Name',
  },
  purchasemeal: {
    currentpackage: 'Current package',
    purchasePackage: 'Choose Plan',
    purchaseRecords: 'VIP Order History',
    memberPackage: 'VIP Type',
    activeStatus: 'Active Status',
    memberPoints: 'VIP Points',
    memberLevel: 'VIP Level',
    memberBenefitsDescription: 'VIP Benefits Description',
    rewardGenerations: 'Commission Tiers',
    purchase: 'Buy Now',
  },
  memberexplain: {
    memberBenefitsDescription: 'VIP Benefits Description',
  },
  purchasehistory: {
    purchaseRecords: 'VIP Order History',
    name: 'Name',
    Count: 'Quantity',
    takeEffect: 'Effective Quantity',
    price: 'Price',
    memberPoints: 'Member Points',
    rewardGenerations: 'Commission Tiers',
    purchaseTime: 'Purchase Time',
    status: 'Status',
    applyRefund: 'Apply for Refund',
    pendingPayment: 'Pending Payment',
    paymentProcessing: 'Payment Processing',
    authorized: 'Authorized',
    partiallyPaidGiftCard: 'Partially Paid (Using Gift Card)',
    paymentReceived: 'Payment Received',
    paymentCancelled: 'Payment Cancelled',
    paymentFailed: 'Payment Failed',
    refundProcessing: 'Refund Processing',
    refundFailed: 'Refund Failed',
    fullRefund: 'Full Refund',
    partialRefund: 'Partial Refund',
  },
  order: {
    orderManagement: 'My Shop Orders',
    orderNumber: 'Order Number',
    enterOrderNumber: 'Please enter order number',
    orderTime: 'Order Time',
    startDate: 'Start Date',
    endDate: 'End Date',
    orderStatus: 'Order Status',
    pleaseSelect: 'Please Select',
    filter: 'Filter',
    orderInfo: 'Order Information',
    orderId: 'Order ID',
    customerLastName: 'Customer Last Name',
    customerName: 'Customer Name',
    customerPhone: 'Customer Phone',
    totalAmount: 'Total Amount',
    shippingAddress: 'Shipping Address',
    orderDetails: 'Order Details',
    applyRefund: 'Apply for Refund',
    noData: 'No Data',
  },
  orderinfo: {
    orderManagement: 'My Shop Orders',
    orderInfo: 'Order Information',
    orderId: 'Order ID',
    notes: 'Notes (Remarks)',
    orderStatus: 'Order Status',
    logisticsStatus: 'Logistics Status',
    orderTime: 'Order Time',
    paymentInfo: 'Payment Information',
    paymentMethod: 'Payment Method',
    totalTax: 'Total Tax',
    currency: 'Currency',
    totalShippingFee: 'Total Shipping Fee',
    totalPrice: 'Total Price',
    customerInfo: 'Customer Information',
    customerLastName: 'Customer Last Name',
    shippingAddress: 'Shipping Address',
    customerName: 'Customer Name',
    phoneNumber: 'Phone Number',
    refundInfo: 'Refund Information',
    refundReason: 'Refund Reason',
    applicationTime: 'Application Time',
    refundStatus: 'Refund Status',
    cancelApplication: 'Cancel Application',
  },
  notify: {
    messageNotifications: 'Notifications',
    all: 'All',
    systemMessages: 'System Messages',
    systemAnnouncements: 'Primary',
    eventNotifications: 'Promotions',
    markAllAsRead: 'Mark All as Read',
    viewDetails: 'View Details',
    noData: 'No Data',
  },
  notifyinfo: {
    signUp: 'Sign Up',
    download: 'Download',
  },
  points_RP: {
    pointsDetails: 'My Points',
    pendingSettlement: 'Pending',
    settlementAvailable: 'Available',
    redeemVoucher: 'Redeem Voucher',
    redeemGiftCard: 'Redeem Gift Card',
    transfer: 'Transfer',
    transactionNumber: 'Transaction Number',
    creditTime: 'Deposit Time',
    noData: 'No Data',
    transferHp: 'Transfer GP',
    transferQuantity: 'Transfer Points',
    enterTransferQuantity: 'Please enter Tranfer Points',
    userUuid: 'User UUID',
    enterUserUuid: 'Please enter User UUID',
    hpTransferableBalance: 'GP Transferable Balance',
    queryUserName: 'Query User Name',
    confirm: 'Confirm',
    cancel: 'Cancel',
    search: 'Search',
  },
  redeem: {
    voucher: 'Voucher',
    discount: 'Discount',
    requiredPoints: 'Required Points',
    minimumSpend: 'Minimum Spend',
    noMinimumSpend: 'No Minimum Spend',
    validityPeriod: 'Validity Period',
    to: 'To',
    redeemNow: 'Redeem Now',
    noData: 'No Data',
    fullReduction: 'Full Reduction',
    designatedProducts: 'Designated Products',
  },
  redeem_HP: {
    hpRedeemVoucher: 'GP Redeem Gift Card',
    pointsBalance: 'Points Balance',
    operationGuide: 'Operation Guide',
    enterProductPriceToBuy:
      'Please enter the price of the product you would like to purchase',
    enterProductPrice: 'Please enter product price',
    redeemValue: 'Redeem Value ($)',
    enterVoucherRedeemAmount:
      'Please enter the redemption amount for the gift card',
    redeemPointsSpent: 'Redeemed Points',
  },
  memberpointsdetail: {
    title: 'VIP Points Details',
    date: 'Date',
  },
  exchangecode: {
    redeemVoucher: 'Redeem Voucher',
    myVouchers: 'My Vouchers（RP）',
    voucherCode: 'Voucher Code',
    myGiftCards: 'My Gift Cards（GP）',
    remaining: 'Remaining',
    discount: 'Discount',
    redeemType: 'Redeem Type',
    minimumSpend: 'Minimum Spend',
    noMinimumSpend: 'No Minimum Spend',
    validityPeriod: 'Validity Period',
    noExpiry: 'No Expiry',
    to: 'To',
    reduce: 'Reduce',
    copyVoucherCode: 'Copy Voucher Code',
    noData: 'No Data',
  },
  productintroduce: {
    productIntroduction: 'Product Introduction',
  },
}
